import { BubbleSpinners } from '~/components/ui/bubble-spinner'
import { Button } from '~/components/ui/button'

import type { ButtonProps } from '~/components/ui/button'

export interface SubmissionButtonProps extends ButtonProps {
  isSubmitting?: boolean
  bubbleSize?: string
}

export default function SubmissionButton({
  isSubmitting,
  bubbleSize,
  children,
  ...props
}: SubmissionButtonProps) {
  return (
    <Button type='submit' {...props}>
      {isSubmitting ? (
        <BubbleSpinners
          size={bubbleSize ?? '24px'}
          color={props.color ?? '#ffffff'}
        />
      ) : (
        children
      )}
    </Button>
  )
}
